<script>
export default {
    props: {
        appFrontendUrl: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        impersonate(userId) {
            this.isLoading = true;

            axios
                .get(this.route("users.login-as", { user: userId }))
                .then(({ data }) => {
                    window.open(
                        this.appFrontendUrl +
                            "/login?logout=1&ib_exchange_code=" +
                            data.exchange_code,
                        "_blank"
                    );
                })
                .catch((error) => {
                    console.error(error);
                    this.$notifications.error(
                        "Can't impersonate. Try again later"
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
